import React from 'react'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import type { DropdownOption } from 'blocks.simple/dropdown/dropdown.local.methods'
import type {
    EditableDropdownDefaultProps,
    EditableDropdownProps,
    EditableDropdownState,
} from './editableDropdown.types'

const isDropdownValue = (value: unknown): value is string | number | boolean | null =>
    value === null || ['string', 'number', 'boolean'].includes(typeof value)

const getOptionValue = (option: object, valueField = 'id') => {
    const value = (option as Record<string, unknown>)[valueField]
    return isDropdownValue(value) ? value : undefined
}

class EditableDropdown<Option extends object = Record<string, unknown>> extends React.Component<
    EditableDropdownProps<Option>,
    EditableDropdownState
> {
    static defaultProps: EditableDropdownDefaultProps

    constructor(p_: EditableDropdownProps<Option>) {
        super(p_)

        this.state = {
            value: p_.value,
            focused: false,
        }
    }
    componentDidUpdate(prevProps: EditableDropdownProps<Option>) {
        const p_ = this.props

        if (p_.value !== prevProps.value) {
            this.setState({ value: p_.value })
        }
    }
    render() {
        const s_ = this.state
        const p_ = this.props

        return (
            <Dropdown
                id={p_.id}
                placeholder={p_.placeholder}
                options={(p_.options as unknown) as DropdownOption[]}
                mod={s_.focused ? p_.activeMod : p_.mod}
                rounded={p_.rounded}
                mask={p_.mask}
                value={s_.value}
                label={p_.label}
                labelField={p_.labelField}
                valueField={p_.valueField}
                onChange={(selected) => {
                    if (typeof selected !== 'object' || selected === null || Array.isArray(selected)) {
                        return
                    }

                    const option = (selected as unknown) as Option

                    if (!p_.onlyPlaceholder) {
                        this.setState({ value: getOptionValue(option, p_.valueField) })
                    }

                    p_.onChange(option)
                }}
                onBlur={function (value, e) {
                    p_.onBlur(value, e)
                }}
                onHide={() => this.setState({ focused: false })}
                onShow={() => this.setState({ focused: true })}
                showIconOnHover={p_.showIconOnHover}
                searchable={true}
                wrapperWidth={true}
                config={p_.config}
                indentSize={p_.indentSize}
                onlyPlaceholder={p_.onlyPlaceholder}
                disabled={p_.disabled}
                showCustomOption={p_.showCustomOption}
                hideNotFound={p_.hideNotFound}
                className={p_.className}
            />
        )
    }
}

EditableDropdown.defaultProps = {
    id: 'autosize_input',
    onChange: () => {},
    onBlur: () => {},
    mod: 'none',
    activeMod: 'withShadow',
    rounded: 'none',
    showIconOnHover: true,
}

export default EditableDropdown
